/**
 * Preserving Muscle section custom element.
 * Read More / Read Less is handled by the shared read-more.js component.
 */
if (!customElements.get("preserving-muscle")) {
  customElements.define("preserving-muscle", class PreservingMuscle extends HTMLElement {});
}
